import { useEffect, useState } from 'react';
import { getMultimediaLevelById, updateMultimediaLevel } from '../../services/multimediaLevel/editMultimediaLevelService.js';
import { isNameValid, isDescriptionValid } from '../../utils/validations/multimediaLevelValidations.js';

const initialForm = {
    name: '',
    description: ''
};

export const useEditMultimediaLevel = (id) => {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);

    useEffect(() => {
        const loadMultimediaLevel = async () => {
            try {
                const multimediaLevel = await getMultimediaLevelById(id);
                setForm({ ...initialForm, ...multimediaLevel });
            } catch (err) {
                setError(
                    err.response?.status === 404
                        ? 'Nivel multimedia no encontrado.'
                        : 'Error al obtener los datos del nivel multimedia.'
                );
            }
        };

        loadMultimediaLevel();
    }, [id]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submit = async () => {
        if (!isNameValid(form.name)){
            setError('El nombre del nivel solo pueden contener letras.');
            return;
        }
        if (!isDescriptionValid(form.description)){
            setError('La descripción no puede contener caracteres especiales.');
            return;
        }
        // Si todo esta validado, procedimiento guardar
        try {
            await updateMultimediaLevel(id, {
                ...form
            });
            setSuccess('El nivel multimedia ha sido actualizado exitosamente.');
            setValidationErrors([]);
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error al actualizar el nivel multimedia.'
            );
        }
    }

    const clearMessages = () => {
        setError('');
        setSuccess('');
        setValidationErrors([]);
    };

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearMessages
    };
}